import axios from 'axios';
import Cookies from 'js-cookie';

// Use relative URL for proxy support, or full URL if VITE_API_URL is set
const API_URL = import.meta.env.VITE_API_URL || '';

const api = axios.create({
  baseURL: API_URL ? `${API_URL}/api/v1` : '/api/v1',
  headers: {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true',  // Skip ngrok interstitial page
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
  },
});

// Use different cookie name than Universe client to avoid conflicts
const AUTH_COOKIE_NAME = '_auth_parent';

// Add auth token and locale to requests
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get(AUTH_COOKIE_NAME);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Send user's language preference to server
    const locale = localStorage.getItem('i18nextLng') || 'en';
    config.headers['Accept-Language'] = locale;
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      Cookies.remove(AUTH_COOKIE_NAME);
      localStorage.removeItem('userName');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
